import * as THREE from 'three';
import {Line} from "../../Shapes/Line";
import {LineCurved} from "../../Shapes/LineCurved";
import {Disk} from "../../Shapes/Disk";
import {NetworkZone} from "../../Shapes/NetworkZone";
import {ManagerServers} from "./ManagerServers";
import {Server} from "../../../../../../../services/model/server.model";

export function ManagerServerLeft(
    scene: THREE.Scene,
    x: number,
    z: number,
    qte: number,
    zoneName: string,
	id: string,
    servers: Array<Server>,
): void {
    // Constantes
    const blancColor = 0xffffff;
    const roseColor = 0xA890F3;
    const violetColor = 0xA890F3;
    const radius = 1;

    // Création de la ligne de départ (à faire en fonction du nombre de serveurs)
    const lineLength: number = qte === 0 ? 7 : ((qte < 4 ? qte : 4) * 2) + 5;
    Line(scene, x, z, x - lineLength, z);
    LineCurved(scene, x - lineLength, z, radius, 'ES');
    const zoneX: number = x - lineLength - radius;
    const zoneZ: number = z + radius;
    Line(scene, zoneX, zoneZ, zoneX, zoneZ + 2)
    Disk(scene, zoneX, zoneZ + 2, 0.2, blancColor, violetColor);

    // Création de la zone (ajustement en fonction du nombre de serveurs)
    const zoneWidth = qte == 0 ? 6 : ((qte < 4 ? qte : 4) * 4) + 2;
    let zoneHeight = qte == 0 ? 6 : (Math.ceil(qte / 4) * 4) + 2;
	if (zoneHeight > 11) {
		zoneHeight = 10
	}
    NetworkZone(scene, zoneX, zoneZ + 2, zoneWidth, zoneHeight, 0.5, roseColor, violetColor, 0.01, zoneName, id);

    ManagerServers(scene, zoneX, zoneZ + 2, qte, servers)
}
